import { FC, Fragment } from 'react';
import { VTEquipmentAnomalyData } from '../../../../utils/models';
import { getVTEquipmentColumns } from '../../../../utils/data';

import AutTable from '../../../blocks/aut-grid-table';
import VTEquipmentAnomalyItem from '../../../forms/vt/vtEquipmentAnomalyItem';

interface VTPEquipmentSummaryProps {
	anomalyData: VTEquipmentAnomalyData[];
	onDataChange: (items: VTEquipmentAnomalyData[]) => void;
}

const VTEquipmentSummary: FC<VTPEquipmentSummaryProps> = (props) => {
	const handleAddItem = (item: VTEquipmentAnomalyData) => {
		const newAnomalyData = [...props.anomalyData];
		newAnomalyData.push({ ...item, id: props.anomalyData.length + 1 });

		props.onDataChange(newAnomalyData);
	};

	const handleDeleteItem = (item: VTEquipmentAnomalyData): void => {
		const newAnomalyData: VTEquipmentAnomalyData[] = props.anomalyData.filter(
			(i) => i.id !== item.id
		);
		props.onDataChange(newAnomalyData);
	};

	return (
		<Fragment>
			<VTEquipmentAnomalyItem onAdd={handleAddItem} />

			<div className="divider my-4"></div>

			<AutTable
				data={props.anomalyData}
				tableColumns={getVTEquipmentColumns()}
				onDeleteItem={handleDeleteItem}
			/>
		</Fragment>
	);
};

export default VTEquipmentSummary;
